// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '../../DataCache';
import { TvInteriorIdCache } from '../Caches/TvInteriorIdCache';
import { TvSymbolConvertor } from '../Convertors/TvSymbolConvertor';
class _TvSavedDataHelper {
    correctChartSettings(defaultChartSettings) {
        if (!isValidArray(defaultChartSettings === null || defaultChartSettings === void 0 ? void 0 : defaultChartSettings.charts)) {
            return;
        }
        const charts = defaultChartSettings.charts;
        for (const chart of charts) {
            const state = chart.panes[0].sources[0].state;
            const symbolName = state.symbol;
            if (!isValidString(symbolName)) {
                return;
            }
            const interiorId = TvInteriorIdCache.getInteriorId(symbolName);
            const currentInstrument = DataCache.getInstrumentByName(interiorId);
            if (isNullOrUndefined(currentInstrument)) {
                const newInstrument = DataCache.getAnyInstrument();
                if (!isNullOrUndefined(newInstrument)) {
                    TvSymbolConvertor.correctTvChartState(state, newInstrument);
                }
            }
        }
    }
    correctInitialSettings(initSettings) {
        if (isNullOrUndefined(initSettings)) {
            return;
        }
        const prefix = 'savedwatch';
        const regex = new RegExp(`^${prefix}\\.\\w+$`);
        const watchlistKeys = Object.keys(initSettings).filter((key) => regex.test(key));
        for (const watchlistKey of watchlistKeys) {
            const watchlistInfoJSON = initSettings[watchlistKey];
            const watchlistInfo = JSON.parse(watchlistInfoJSON);
            const newSymbols = this.getCorrectListOfSymbols(watchlistInfo.symbols);
            if (newSymbols.length !== watchlistInfo.symbols.length) {
                watchlistInfo.symbols = newSymbols;
                initSettings[watchlistKey] = JSON.stringify(watchlistInfo);
            }
        }
    }
    getCorrectListOfSymbols(symbols) {
        const correctSymbols = [];
        const sectionStartKey = '###';
        for (const symbolName of symbols) {
            if (symbolName.startsWith(sectionStartKey)) {
                correctSymbols.push(symbolName);
                continue;
            }
            const interiorId = TvInteriorIdCache.getInteriorId(symbolName);
            const instrument = DataCache.getInstrumentByName(interiorId);
            if (isNullOrUndefined(instrument))
                continue;
            correctSymbols.push(symbolName);
        }
        return correctSymbols;
    }
}
export const TvSavedDataHelper = new _TvSavedDataHelper();
